import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { SenderService } from '../../services/sender.service';
import { ModalService } from '../../services/modal.service';
import { InterfaceService } from '../../services/interface.service';
import { Router } from '@angular/router';
import { strings as rusStrings } from 'ngx-timeago/language-strings/ru';
import { TimeagoIntl } from 'ngx-timeago';
import { LeadsService } from '../../modules/leads/services/leads.service';
import { BehaviorSubject } from 'rxjs';
import { AllService } from "../../services/all.service";

@Component({
  selector: 'app-leads-navbar',
  templateUrl: './leads-navbar.component.html',
  styleUrls: ['./leads-navbar.component.scss']
})
export class LeadsNavbarComponent implements OnInit {
  open$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @Input() compact = false;
  expiredTariff$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(
    public leadsService: LeadsService,
    private intl: TimeagoIntl,
    public router: Router,
    public interfaceService: InterfaceService,
    public renderer: Renderer2,
    public modalService: ModalService,
    public senderService: SenderService,
    public allService: AllService,
  ) { }

  ngOnInit(): void {
    this.intl.strings = rusStrings;
    this.intl.changes.next();
    this.senderService.account$.subscribe((account) => {
      const val = this.senderService.expiredTariff();
      if (!this.expiredTariff$.value && val) {
        this.openPayTariff();
      }
      this.expiredTariff$.next(val);
    });
  }
  goToMessenger() {
    this.router.navigate(['/ui']);
    this.interfaceService.setFullSize(this.renderer, false);
  }

  toggleSidebar() {
    this.open$.next(!this.open$.value);
  }

  openPayTariff() {
    this.modalService.openModal('ModalLeadsTariffComponent');
  }
}
